<template>
  <div class="mt-events">
    Events
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>
